module.exports = __webpack_public_path__ + "assets/img/order_6.c4e4b221.svg";